// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";

function stringifyMark(component) {
  if (typeof component !== "number") {
    return component._0;
  }
  switch (component) {
    case /* Underlined */0 :
        return "underlined";
    case /* Italic */1 :
        return "italic";
    case /* Bold */2 :
        return "bold";
    case /* DropDownOptionContainer */3 :
        return "DropDownOptionContainer";
    case /* CodeMarkComponent */4 :
        return "code";
    case /* TextInputContainer */5 :
        return "TextInputContainer";
    case /* SkilfulTextInputContainer */6 :
        return "SkilfulTextInputContainer";
    case /* SkilfulDropDownOptionContainer */7 :
        return "SkilfulDropDownOptionContainer";
    case /* GroupedMcCheckboxClickToAddToGroupAndHighlight */8 :
        return "GroupedMcCheckbox.ClickToAddToGroupAndHighlight";
    case /* SkilfulHighlightClickToAddToBucket */9 :
        return "SkilfulHighlightClickToAddToBucket";
    
  }
}

function stringifyInline(component) {
  switch (component) {
    case /* Img */0 :
        return "Img";
    case /* InlineStyleClassName */1 :
        return "InlineStyleClassName";
    case /* UnknownInlineComponent */2 :
        return "UnknownInlineComponent";
    case /* SkilfulClozeDropTextContainer */3 :
        return "SkilfulClozeDropTextContainer";
    case /* ClozeDropTextContainer */4 :
        return "ClozeDropTextContainer";
    
  }
}

function stringifyBlock(component) {
  switch (component) {
    case /* NumberedList */0 :
        return "numbered-list";
    case /* Table */1 :
        return "table";
    case /* TableCell */2 :
        return "table_cell";
    case /* TableRow */3 :
        return "table_row";
    case /* BulletedList */4 :
        return "bulleted-list";
    case /* ListItem */5 :
        return "list-item";
    case /* HeadingOne */6 :
        return "heading-one";
    case /* HeadingTwo */7 :
        return "heading-two";
    case /* BlockStyleClassName */8 :
        return "BlockStyleClassName";
    case /* ExerciseLayoutContainer */9 :
        return "ExerciseLayoutContainer";
    case /* McResponseRequired */10 :
        return "MC.ResponseRequired";
    case /* McExactResponseRequired */11 :
        return "MC.ExactResponseRequired";
    case /* McSingleResponse */12 :
        return "MC.SingleResponse";
    case /* McMultipleResponse */13 :
        return "MC.MultipleResponse";
    case /* UnknownBlockComponent */14 :
        return "UnknownBlockComponent";
    case /* V2ClozeChoiceProvider */15 :
        return "V2ClozeChoiceProvider";
    case /* ClozeChoiceProvider */16 :
        return "ClozeChoiceProvider";
    case /* SkilfulClozeDragTextContainer */17 :
        return "SkilfulClozeDragTextContainer";
    case /* ClozeDragTextContainer */18 :
        return "ClozeDragTextContainer";
    case /* ShuffleBlockChildren */19 :
        return "ShuffleChildren";
    case /* DropDownContainer */20 :
        return "DropDownContainer";
    case /* ShowAnswerWrapper */21 :
        return "ShowAnswerWrapper";
    case /* Alignment */22 :
        return "alignment";
    case /* SideDrawer */23 :
        return "SideDrawer";
    case /* ShowContent */24 :
        return "ShowContent";
    case /* GroupedMcCheckboxGroupProvider */25 :
        return "GroupedMcCheckbox.GroupProvider";
    case /* GroupedMcCheckboxSetGroupButton */26 :
        return "GroupedMcCheckbox.SetGroupButton";
    case /* SkilfulLayoutContainer */27 :
        return "SkilfulLayoutContainer";
    case /* PieceOfCakeLayoutContainer */28 :
        return "PieceOfCakeLayoutContainer";
    case /* SkilfulQuestionVisible */29 :
        return "SkilfulQuestionVisible";
    case /* PieceOfCakeQuestionVisible */30 :
        return "PieceOfCakeQuestionVisible";
    case /* SkilfulMultiChoiceContainer */31 :
        return "SkilfulMultiChoiceContainer";
    case /* PieceOfCakeMultiChoiceContainer */32 :
        return "PieceOfCakeMultiChoiceContainer";
    case /* SkilfulMultiChoiceSingleResponseContainer */33 :
        return "SkilfulMultiChoiceSingleResponseContainer";
    case /* PieceOfCakeMultiChoiceSingleResponseContainer */34 :
        return "PieceOfCakeMultiChoiceSingleResponseContainer";
    case /* SkilfulMultiChoiceMultiResponseContainer */35 :
        return "SkilfulMultiChoiceMultiResponseContainer";
    case /* PieceOfCakeMultiChoiceMultiResponseContainer */36 :
        return "PieceOfCakeMultiChoiceMultiResponseContainer";
    case /* K2BookQuestions */37 :
        return "K2BookQuestions";
    case /* K2Answers */38 :
        return "K2Answers";
    case /* SkilfulStemHeading */39 :
        return "SkilfulStemHeading";
    case /* StemHeading */40 :
        return "StemHeading";
    case /* ImageSoundQuestion */41 :
        return "ImageSoundQuestion";
    case /* AnswerBox */42 :
        return "AnswerBox";
    case /* AnswerBoxMed */43 :
        return "AnswerBoxMed";
    case /* AnswerBoxSlim */44 :
        return "AnswerBoxSlim";
    case /* AudioQuestionContainer */45 :
        return "AudioQuestionContainer";
    case /* SkilfulRadioButtonMultiChoice */46 :
        return "SkilfulRadioButtonMultiChoice";
    case /* SkilfulCheckboxButtonMultiChoice */47 :
        return "SkilfulCheckboxButtonMultiChoice";
    case /* SkilfulContent */48 :
        return "SkilfulContent";
    case /* SkilfulDragPanelSticky */49 :
        return "SkilfulDragPanelSticky";
    case /* SkilfulStimulusContainer */50 :
        return "SkilfulStimulusContainer";
    case /* SkilfulQuestionContent */51 :
        return "SkilfulQuestionContent";
    case /* SkilfulStimulusTabContent */52 :
        return "SkilfulStimulusTabContent";
    case /* SkilfulHighlightProvider */53 :
        return "SkilfulHighlightProvider";
    case /* SkilfulHighlightBucket */54 :
        return "SkilfulHighlightBucket";
    
  }
}

function parseMark(component) {
  switch (component) {
    case "DropDownOptionContainer" :
        return /* DropDownOptionContainer */3;
    case "GroupedMcCheckbox.ClickToAddToGroupAndHighlight" :
        return /* GroupedMcCheckboxClickToAddToGroupAndHighlight */8;
    case "SkilfulDropDownOptionContainer" :
        return /* SkilfulDropDownOptionContainer */7;
    case "SkilfulHighlightClickToAddToBucket" :
        return /* SkilfulHighlightClickToAddToBucket */9;
    case "SkilfulTextInputContainer" :
        return /* SkilfulTextInputContainer */6;
    case "TextInputContainer" :
        return /* TextInputContainer */5;
    case "bold" :
        return /* Bold */2;
    case "code" :
        return /* CodeMarkComponent */4;
    case "italic" :
        return /* Italic */1;
    case "underlined" :
        return /* Underlined */0;
    default:
      return /* UnknownMarkComponent */{
              _0: component
            };
  }
}

function parseInline(component) {
  switch (component) {
    case "ClozeDropTextContainer" :
        return /* ClozeDropTextContainer */4;
    case "Img" :
        return /* Img */0;
    case "InlineStyleClassName" :
        return /* InlineStyleClassName */1;
    case "SkilfulClozeDropTextContainer" :
        return /* SkilfulClozeDropTextContainer */3;
    default:
      return /* UnknownInlineComponent */2;
  }
}

function parseBlock(component) {
  switch (component) {
    case "AnswerBox" :
        return /* AnswerBox */42;
    case "AnswerBoxMed" :
        return /* AnswerBoxMed */43;
    case "AnswerBoxSlim" :
        return /* AnswerBoxSlim */44;
    case "AudioQuestionContainer" :
        return /* AudioQuestionContainer */45;
    case "BlockStyleClassName" :
        return /* BlockStyleClassName */8;
    case "ClozeChoiceProvider" :
        return /* ClozeChoiceProvider */16;
    case "ClozeDragTextContainer" :
        return /* ClozeDragTextContainer */18;
    case "DropDownContainer" :
        return /* DropDownContainer */20;
    case "ExerciseLayoutContainer" :
        return /* ExerciseLayoutContainer */9;
    case "GroupedMcCheckbox.GroupProvider" :
        return /* GroupedMcCheckboxGroupProvider */25;
    case "GroupedMcCheckbox.SetGroupButton" :
        return /* GroupedMcCheckboxSetGroupButton */26;
    case "ImageSoundQuestion" :
        return /* ImageSoundQuestion */41;
    case "K2Answers" :
        return /* K2Answers */38;
    case "K2BookQuestions" :
        return /* K2BookQuestions */37;
    case "MC.ExactResponseRequired" :
        return /* McExactResponseRequired */11;
    case "MC.MultipleResponse" :
        return /* McMultipleResponse */13;
    case "MC.ResponseRequired" :
        return /* McResponseRequired */10;
    case "MC.SingleResponse" :
        return /* McSingleResponse */12;
    case "PieceOfCakeLayoutContainer" :
        return /* PieceOfCakeLayoutContainer */28;
    case "PieceOfCakeMultiChoiceContainer" :
        return /* PieceOfCakeMultiChoiceContainer */32;
    case "PieceOfCakeMultiChoiceMultiResponseContainer" :
        return /* PieceOfCakeMultiChoiceMultiResponseContainer */36;
    case "PieceOfCakeMultiChoiceSingleResponseContainer" :
        return /* PieceOfCakeMultiChoiceSingleResponseContainer */34;
    case "PieceOfCakeQuestionVisible" :
        return /* PieceOfCakeQuestionVisible */30;
    case "ShowAnswerWrapper" :
        return /* ShowAnswerWrapper */21;
    case "ShowContent" :
        return /* ShowContent */24;
    case "ShuffleChildren" :
        return /* ShuffleBlockChildren */19;
    case "SideDrawer" :
        return /* SideDrawer */23;
    case "SkilfulCheckboxButtonMultiChoice" :
        return /* SkilfulCheckboxButtonMultiChoice */47;
    case "SkilfulClozeDragTextContainer" :
        return /* SkilfulClozeDragTextContainer */17;
    case "SkilfulContent" :
        return /* SkilfulContent */48;
    case "SkilfulDragPanelSticky" :
        return /* SkilfulDragPanelSticky */49;
    case "SkilfulHighlightBucket" :
        return /* SkilfulHighlightBucket */54;
    case "SkilfulHighlightProvider" :
        return /* SkilfulHighlightProvider */53;
    case "SkilfulLayoutContainer" :
        return /* SkilfulLayoutContainer */27;
    case "SkilfulMultiChoiceContainer" :
        return /* SkilfulMultiChoiceContainer */31;
    case "SkilfulMultiChoiceMultiResponseContainer" :
        return /* SkilfulMultiChoiceMultiResponseContainer */35;
    case "SkilfulMultiChoiceSingleResponseContainer" :
        return /* SkilfulMultiChoiceSingleResponseContainer */33;
    case "SkilfulQuestionContent" :
        return /* SkilfulQuestionContent */51;
    case "SkilfulQuestionVisible" :
        return /* SkilfulQuestionVisible */29;
    case "SkilfulRadioButtonMultiChoice" :
        return /* SkilfulRadioButtonMultiChoice */46;
    case "SkilfulStemHeading" :
        return /* SkilfulStemHeading */39;
    case "SkilfulStimulusContainer" :
        return /* SkilfulStimulusContainer */50;
    case "SkilfulStimulusTabContent" :
        return /* SkilfulStimulusTabContent */52;
    case "StemHeading" :
        return /* StemHeading */40;
    case "V2ClozeChoiceProvider" :
        return /* V2ClozeChoiceProvider */15;
    case "alignment" :
        return /* Alignment */22;
    case "bulleted-list" :
        return /* BulletedList */4;
    case "heading-one" :
        return /* HeadingOne */6;
    case "heading-two" :
        return /* HeadingTwo */7;
    case "list-item" :
        return /* ListItem */5;
    case "numbered-list" :
        return /* NumberedList */0;
    case "table" :
        return /* Table */1;
    case "table_cell" :
        return /* TableCell */2;
    case "table_row" :
        return /* TableRow */3;
    default:
      return /* UnknownBlockComponent */14;
  }
}

function decodeQuestionIndex(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "questionIndex",
                  tl: /* [] */0
                }
              }, Json_decode.$$int)(json);
}

function decodeResponseRequired(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "correctAnswer",
                    tl: /* [] */0
                  }
                }, (function (param) {
                    return Json_decode.array(Json_decode.string, param);
                  }))(json)
        ];
}

function decodeMultiCoiceContainer(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "correctAnswer",
                    tl: /* [] */0
                  }
                }, (function (param) {
                    return Json_decode.array(Json_decode.string, param);
                  }))(json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "columns",
                      tl: /* [] */0
                    }
                  }, Json_decode.$$int), json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "showCorrectAnswerBehaviour",
                      tl: /* [] */0
                    }
                  }, Json_decode.bool), json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "fuzzyMark",
                      tl: /* [] */0
                    }
                  }, Json_decode.bool), json)
        ];
}

function decodeMc(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "responseOptionId",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeLayoutContainer(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionCount",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "stimuliPresent",
                      tl: /* [] */0
                    }
                  }, Json_decode.bool), json)
        ];
}

function skilfulDecodeLayoutContainer(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionCount",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "title",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "stimuliPresent",
                      tl: /* [] */0
                    }
                  }, Json_decode.bool), json)
        ];
}

function pieceOfCakeDecodeLayoutContainer(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionCount",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "stimuliPresent",
                      tl: /* [] */0
                    }
                  }, Json_decode.bool), json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "stimulusId",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "stimulusType",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json)
        ];
}

function decodeSkilfulClozeDragText(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "id",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeClozeDragText(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "id",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "group",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeClozeDropText(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "id",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodePieceOfCakeMultiChoice(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "responseOptionId",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeAlignment(json) {
  return Json_decode.optional(Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "align",
                    tl: /* [] */0
                  }
                }, Json_decode.string), json);
}

function parseClassname(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "className",
                  tl: /* [] */0
                }
              }, Json_decode.string)(json);
}

function decodeSideDrawer(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "tabs",
                  tl: /* [] */0
                }
              }, (function (param) {
                  return Json_decode.array(Json_decode.string, param);
                }))(json);
}

function decodeShowContent(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "value",
                  tl: /* [] */0
                }
              }, Json_decode.string)(json);
}

function decodeSetGroupButton(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "group",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "colour",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeClickToAddToGroupAndHighlight(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "responseOptionId",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeImageAndAudioId(json) {
  return [
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "imageSrc",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "audioId",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json)
        ];
}

function decodeGropProvider(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "defaultGroup",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "defaultColour",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeBookId(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "bookId",
                  tl: /* [] */0
                }
              }, Json_decode.string)(json);
}

function decodeAudioComponent(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "audioId",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        ];
}

function decodeStimulusTabContent(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "tab",
                  tl: /* [] */0
                }
              }, Json_decode.string)(json);
}

function parseBlockPayload(component, json) {
  var exit = 0;
  switch (component) {
    case /* HeadingOne */6 :
    case /* HeadingTwo */7 :
    case /* BlockStyleClassName */8 :
        exit = 4;
        break;
    case /* ExerciseLayoutContainer */9 :
        var match = decodeLayoutContainer(json);
        var stimuliPresent = match[1];
        var questionCount = match[0];
        return Json_encode.object_(stimuliPresent !== undefined ? ({
                        hd: [
                          "questionCount",
                          questionCount
                        ],
                        tl: {
                          hd: [
                            "stimuliPresent",
                            stimuliPresent
                          ],
                          tl: /* [] */0
                        }
                      }) : ({
                        hd: [
                          "questionCount",
                          questionCount
                        ],
                        tl: /* [] */0
                      }));
    case /* McResponseRequired */10 :
        var match$1 = decodeResponseRequired(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$1[0]
                    ],
                    tl: {
                      hd: [
                        "correctAnswer",
                        Json_encode.array((function (prim) {
                                return prim;
                              }), match$1[1])
                      ],
                      tl: /* [] */0
                    }
                  });
    case /* McExactResponseRequired */11 :
        var match$2 = decodeResponseRequired(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$2[0]
                    ],
                    tl: {
                      hd: [
                        "correctAnswer",
                        Json_encode.array((function (prim) {
                                return prim;
                              }), match$2[1])
                      ],
                      tl: /* [] */0
                    }
                  });
    case /* SkilfulClozeDragTextContainer */17 :
        var match$3 = decodeSkilfulClozeDragText(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$3[0]
                    ],
                    tl: {
                      hd: [
                        "id",
                        match$3[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    case /* ClozeDragTextContainer */18 :
        var match$4 = decodeClozeDragText(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$4[0]
                    ],
                    tl: {
                      hd: [
                        "id",
                        match$4[1]
                      ],
                      tl: {
                        hd: [
                          "group",
                          match$4[2]
                        ],
                        tl: /* [] */0
                      }
                    }
                  });
    case /* V2ClozeChoiceProvider */15 :
    case /* ClozeChoiceProvider */16 :
    case /* DropDownContainer */20 :
    case /* ShowAnswerWrapper */21 :
        exit = 3;
        break;
    case /* Alignment */22 :
        var align = decodeAlignment(json);
        return Json_encode.object_(align !== undefined ? ({
                        hd: [
                          "align",
                          align
                        ],
                        tl: /* [] */0
                      }) : ({
                        hd: [
                          "align",
                          "left"
                        ],
                        tl: /* [] */0
                      }));
    case /* ShowContent */24 :
        var value = decodeShowContent(json);
        return Json_encode.object_({
                    hd: [
                      "value",
                      value
                    ],
                    tl: /* [] */0
                  });
    case /* SkilfulLayoutContainer */27 :
        var match$5 = skilfulDecodeLayoutContainer(json);
        var stimuliPresent$1 = match$5[2];
        var title = match$5[1];
        var questionCount$1 = match$5[0];
        return Json_encode.object_(stimuliPresent$1 !== undefined ? ({
                        hd: [
                          "questionCount",
                          questionCount$1
                        ],
                        tl: {
                          hd: [
                            "title",
                            title
                          ],
                          tl: {
                            hd: [
                              "stimuliPresent",
                              stimuliPresent$1
                            ],
                            tl: /* [] */0
                          }
                        }
                      }) : ({
                        hd: [
                          "questionCount",
                          questionCount$1
                        ],
                        tl: {
                          hd: [
                            "title",
                            title
                          ],
                          tl: /* [] */0
                        }
                      }));
    case /* PieceOfCakeLayoutContainer */28 :
        var match$6 = pieceOfCakeDecodeLayoutContainer(json);
        var stimuliPresent$2 = match$6[1];
        var questionCount$2 = match$6[0];
        var tmp;
        var exit$1 = 0;
        if (stimuliPresent$2 !== undefined) {
          var stimulusId = match$6[2];
          if (stimulusId !== undefined) {
            var stimulusType = match$6[3];
            if (stimulusType !== undefined) {
              tmp = {
                hd: [
                  "questionCount",
                  questionCount$2
                ],
                tl: {
                  hd: [
                    "stimuliPresent",
                    stimuliPresent$2
                  ],
                  tl: {
                    hd: [
                      "stimulusId",
                      stimulusId
                    ],
                    tl: {
                      hd: [
                        "stimulusType",
                        stimulusType
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
            } else {
              exit$1 = 10;
            }
          } else {
            exit$1 = 10;
          }
        } else {
          exit$1 = 10;
        }
        if (exit$1 === 10) {
          tmp = {
            hd: [
              "questionCount",
              questionCount$2
            ],
            tl: /* [] */0
          };
        }
        return Json_encode.object_(tmp);
    case /* SkilfulQuestionVisible */29 :
    case /* PieceOfCakeQuestionVisible */30 :
        exit = 7;
        break;
    case /* SkilfulMultiChoiceContainer */31 :
    case /* PieceOfCakeMultiChoiceContainer */32 :
        exit = 8;
        break;
    case /* SkilfulMultiChoiceSingleResponseContainer */33 :
    case /* PieceOfCakeMultiChoiceSingleResponseContainer */34 :
    case /* SkilfulMultiChoiceMultiResponseContainer */35 :
    case /* PieceOfCakeMultiChoiceMultiResponseContainer */36 :
        exit = 9;
        break;
    case /* ImageSoundQuestion */41 :
        var match$7 = decodeImageAndAudioId(json);
        return Json_encode.object_(Belt_List.concat(Belt_List.concat(/* [] */0, Belt_Option.mapWithDefault(match$7[1], /* [] */0, (function (audioId) {
                                  return {
                                          hd: [
                                            "audioId",
                                            audioId
                                          ],
                                          tl: /* [] */0
                                        };
                                }))), Belt_Option.mapWithDefault(match$7[0], /* [] */0, (function (imageSrc) {
                              return {
                                      hd: [
                                        "imageSrc",
                                        imageSrc
                                      ],
                                      tl: /* [] */0
                                    };
                            }))));
    case /* AudioQuestionContainer */45 :
        var match$8 = decodeAudioComponent(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$8[0]
                    ],
                    tl: {
                      hd: [
                        "audioId",
                        match$8[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    case /* McSingleResponse */12 :
    case /* McMultipleResponse */13 :
    case /* SkilfulRadioButtonMultiChoice */46 :
    case /* SkilfulCheckboxButtonMultiChoice */47 :
        exit = 2;
        break;
    case /* SideDrawer */23 :
    case /* SkilfulStimulusContainer */50 :
        exit = 5;
        break;
    case /* NumberedList */0 :
    case /* Table */1 :
    case /* TableCell */2 :
    case /* TableRow */3 :
    case /* BulletedList */4 :
    case /* ListItem */5 :
    case /* UnknownBlockComponent */14 :
    case /* ShuffleBlockChildren */19 :
    case /* K2BookQuestions */37 :
    case /* K2Answers */38 :
    case /* SkilfulStemHeading */39 :
    case /* StemHeading */40 :
    case /* AnswerBox */42 :
    case /* AnswerBoxMed */43 :
    case /* AnswerBoxSlim */44 :
    case /* SkilfulContent */48 :
    case /* SkilfulDragPanelSticky */49 :
    case /* SkilfulQuestionContent */51 :
        return Json_encode.object_(/* [] */0);
    case /* SkilfulStimulusTabContent */52 :
        var tab = decodeStimulusTabContent(json);
        return Json_encode.object_({
                    hd: [
                      "tab",
                      tab
                    ],
                    tl: /* [] */0
                  });
    case /* GroupedMcCheckboxGroupProvider */25 :
    case /* SkilfulHighlightProvider */53 :
        exit = 1;
        break;
    case /* GroupedMcCheckboxSetGroupButton */26 :
    case /* SkilfulHighlightBucket */54 :
        exit = 6;
        break;
    
  }
  switch (exit) {
    case 1 :
        var tmp$1;
        var exit$2 = 0;
        var val;
        try {
          val = decodeGropProvider(json);
          exit$2 = 10;
        }
        catch (exn){
          tmp$1 = /* [] */0;
        }
        if (exit$2 === 10) {
          tmp$1 = {
            hd: [
              "defaultGroup",
              val[0]
            ],
            tl: {
              hd: [
                "defaultColour",
                val[1]
              ],
              tl: /* [] */0
            }
          };
        }
        return Json_encode.object_(tmp$1);
    case 2 :
        var match$9 = decodeMc(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$9[0]
                    ],
                    tl: {
                      hd: [
                        "responseOptionId",
                        match$9[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    case 3 :
        var questionIndex = decodeQuestionIndex(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      questionIndex
                    ],
                    tl: /* [] */0
                  });
    case 4 :
        return Json_encode.object_({
                    hd: [
                      "className",
                      parseClassname(json)
                    ],
                    tl: /* [] */0
                  });
    case 5 :
        var tabs = decodeSideDrawer(json);
        return Json_encode.object_({
                    hd: [
                      "tabs",
                      Json_encode.array((function (prim) {
                              return prim;
                            }), tabs)
                    ],
                    tl: /* [] */0
                  });
    case 6 :
        var match$10 = decodeSetGroupButton(json);
        return Json_encode.object_({
                    hd: [
                      "group",
                      match$10[0]
                    ],
                    tl: {
                      hd: [
                        "colour",
                        match$10[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    case 7 :
        var questionIndex$1 = decodeQuestionIndex(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      questionIndex$1
                    ],
                    tl: /* [] */0
                  });
    case 8 :
        var match$11 = decodeMultiCoiceContainer(json);
        return Json_encode.object_(Belt_List.concat(Belt_List.concat(Belt_List.concat({
                                hd: [
                                  "questionIndex",
                                  match$11[0]
                                ],
                                tl: {
                                  hd: [
                                    "correctAnswer",
                                    Json_encode.array((function (prim) {
                                            return prim;
                                          }), match$11[1])
                                  ],
                                  tl: /* [] */0
                                }
                              }, Belt_Option.mapWithDefault(match$11[2], /* [] */0, (function (c) {
                                      return {
                                              hd: [
                                                "columns",
                                                c
                                              ],
                                              tl: /* [] */0
                                            };
                                    }))), Belt_Option.mapWithDefault(match$11[3], /* [] */0, (function (s) {
                                  return {
                                          hd: [
                                            "showCorrectAnswerBehaviour",
                                            s
                                          ],
                                          tl: /* [] */0
                                        };
                                }))), Belt_Option.mapWithDefault(match$11[4], /* [] */0, (function (f) {
                              return {
                                      hd: [
                                        "fuzzyMark",
                                        f
                                      ],
                                      tl: /* [] */0
                                    };
                            }))));
    case 9 :
        var match$12 = decodePieceOfCakeMultiChoice(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$12[0]
                    ],
                    tl: {
                      hd: [
                        "responseOptionId",
                        match$12[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    
  }
}

function parseImgSrc(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "src",
                  tl: /* [] */0
                }
              }, Json_decode.string)(json);
}

function parseInlinePayload(component, json) {
  switch (component) {
    case /* Img */0 :
        return Json_encode.object_({
                    hd: [
                      "src",
                      parseImgSrc(json)
                    ],
                    tl: /* [] */0
                  });
    case /* InlineStyleClassName */1 :
        return Json_encode.object_({
                    hd: [
                      "className",
                      parseClassname(json)
                    ],
                    tl: /* [] */0
                  });
    case /* UnknownInlineComponent */2 :
        return Json_encode.object_(/* [] */0);
    case /* SkilfulClozeDropTextContainer */3 :
    case /* ClozeDropTextContainer */4 :
        break;
    
  }
  var match = decodeClozeDropText(json);
  return Json_encode.object_({
              hd: [
                "questionIndex",
                match[0]
              ],
              tl: {
                hd: [
                  "id",
                  match[1]
                ],
                tl: /* [] */0
              }
            });
}

function decodeDropDownContainer(json) {
  var opt = function (o) {
    return [
            Json_decode.field("responseOptionId", Json_decode.string, o),
            Json_decode.field("value", Json_decode.string, o)
          ];
  };
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "group",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "opts",
                    tl: /* [] */0
                  }
                }, (function (param) {
                    return Json_decode.array(opt, param);
                  }))(json)
        ];
}

function encodeOpts(opts) {
  return Belt_Array.map(opts, (function (param) {
                return Json_encode.object_({
                            hd: [
                              "responseOptionId",
                              param[0]
                            ],
                            tl: {
                              hd: [
                                "value",
                                param[1]
                              ],
                              tl: /* [] */0
                            }
                          });
              }));
}

function encodeAudioSources(sources) {
  return Belt_Array.map(sources, (function (param) {
                return Json_encode.object_({
                            hd: [
                              "source",
                              param[0]
                            ],
                            tl: {
                              hd: [
                                "accent",
                                param[1]
                              ],
                              tl: /* [] */0
                            }
                          });
              }));
}

function parseQuestionIndex(json) {
  return Json_decode.at({
                hd: "data",
                tl: {
                  hd: "questionIndex",
                  tl: /* [] */0
                }
              }, Json_decode.$$int)(json);
}

function decodeTextInput(json) {
  return [
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "questionIndex",
                    tl: /* [] */0
                  }
                }, Json_decode.$$int)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "responseOptionId",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "largeField",
                    tl: /* [] */0
                  }
                }, Json_decode.bool)(json),
          Json_decode.optional(Json_decode.at({
                    hd: "data",
                    tl: {
                      hd: "label",
                      tl: /* [] */0
                    }
                  }, Json_decode.string), json)
        ];
}

function parseMarkPayload(component, json) {
  var exit = 0;
  if (typeof component !== "number") {
    return json;
  }
  switch (component) {
    case /* Underlined */0 :
    case /* Italic */1 :
    case /* Bold */2 :
    case /* CodeMarkComponent */4 :
        return Json_encode.object_(/* [] */0);
    case /* TextInputContainer */5 :
    case /* SkilfulTextInputContainer */6 :
        exit = 2;
        break;
    case /* DropDownOptionContainer */3 :
    case /* SkilfulDropDownOptionContainer */7 :
        exit = 1;
        break;
    case /* GroupedMcCheckboxClickToAddToGroupAndHighlight */8 :
    case /* SkilfulHighlightClickToAddToBucket */9 :
        exit = 3;
        break;
    
  }
  switch (exit) {
    case 1 :
        var match = decodeDropDownContainer(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match[0]
                    ],
                    tl: {
                      hd: [
                        "group",
                        match[1]
                      ],
                      tl: {
                        hd: [
                          "opts",
                          encodeOpts(match[2])
                        ],
                        tl: /* [] */0
                      }
                    }
                  });
    case 2 :
        var match$1 = decodeTextInput(json);
        var label = match$1[3];
        var largeField = match$1[2];
        var responseOptionId = match$1[1];
        var questionIndex = match$1[0];
        return Json_encode.object_(label !== undefined ? ({
                        hd: [
                          "questionIndex",
                          questionIndex
                        ],
                        tl: {
                          hd: [
                            "responseOptionId",
                            responseOptionId
                          ],
                          tl: {
                            hd: [
                              "largeField",
                              largeField
                            ],
                            tl: {
                              hd: [
                                "label",
                                label
                              ],
                              tl: /* [] */0
                            }
                          }
                        }
                      }) : ({
                        hd: [
                          "questionIndex",
                          questionIndex
                        ],
                        tl: {
                          hd: [
                            "responseOptionId",
                            responseOptionId
                          ],
                          tl: {
                            hd: [
                              "largeField",
                              largeField
                            ],
                            tl: /* [] */0
                          }
                        }
                      }));
    case 3 :
        var match$2 = decodeClickToAddToGroupAndHighlight(json);
        return Json_encode.object_({
                    hd: [
                      "questionIndex",
                      match$2[0]
                    ],
                    tl: {
                      hd: [
                        "responseOptionId",
                        match$2[1]
                      ],
                      tl: /* [] */0
                    }
                  });
    
  }
}

export {
  stringifyMark ,
  stringifyInline ,
  stringifyBlock ,
  parseMark ,
  parseInline ,
  parseBlock ,
  decodeQuestionIndex ,
  decodeResponseRequired ,
  decodeMultiCoiceContainer ,
  decodeMc ,
  decodeLayoutContainer ,
  skilfulDecodeLayoutContainer ,
  pieceOfCakeDecodeLayoutContainer ,
  decodeSkilfulClozeDragText ,
  decodeClozeDragText ,
  decodeClozeDropText ,
  decodePieceOfCakeMultiChoice ,
  decodeAlignment ,
  parseClassname ,
  decodeSideDrawer ,
  decodeShowContent ,
  decodeSetGroupButton ,
  decodeClickToAddToGroupAndHighlight ,
  decodeImageAndAudioId ,
  decodeGropProvider ,
  decodeBookId ,
  decodeAudioComponent ,
  decodeStimulusTabContent ,
  parseBlockPayload ,
  parseImgSrc ,
  parseInlinePayload ,
  decodeDropDownContainer ,
  encodeOpts ,
  encodeAudioSources ,
  parseQuestionIndex ,
  decodeTextInput ,
  parseMarkPayload ,
  
}
/* No side effect */
